import { useSetLoading } from "@/utils/useLoader"
import { useHistory } from "react-router"
import { toast } from "react-toastify"
import { CertificateModel } from "../../types/ForgotCredentialsModel"
import { showToast } from "../../utils/ErrorUtils"

const inputs = {
  EMAIL_ADDRESS: "forgotLoginEmailAddress",
  USERNAME: "forgotLoginUsername",
}

const useForgotCredentials = (forgotFunction: any, successMessage: string) => {
  const history = useHistory()
  const setLoading = useSetLoading()

  const submitData = (data: CertificateModel) => {
    setLoading(true)
    forgotFunction(data)
      .client()
      .then((res: any) => {
        if (res.status === 204) {
          history.push("/")
          toast.success(
            <>
              <p>Email successfully sent.</p>
              {successMessage}
            </>,
            { autoClose: 50000, hideProgressBar: true },
          )
        } else {
          throw new Error(`Failed to send recovery email.`)
        }
      })
      .catch((e: any) => {
        showToast("Failed to send recovery email.", e)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return {
    submitData: submitData,
    inputs: inputs,
  }
}

export { useForgotCredentials }
